import { useCallback, useState } from 'react';

export const useDTicketSubscriptionPauseInfoModal = () => {
	const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);

	const openInfoModal = useCallback(() => {
		setIsInfoModalOpen(true);
	}, []);

	const closeInfoModal = useCallback(() => {
		setIsInfoModalOpen(false);
	}, []);

	return {
		isInfoModalOpen,
		openInfoModal,
		closeInfoModal,
	};
};
